module.exports = __webpack_public_path__ + "img/team-17.4c288954.jpg";